"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bootstrapServer = exports.bootstrapClient = exports.initializeWebComponent = exports.serverSideMountFactory = exports.clientSideMountFactory = void 0;
var utils_1 = require("../../utils");
var common_mfe_1 = require("../common-mfe");
function clientSideMountFactory(App, _a) {
    var createApp = _a.createApp;
    return function (el, props) {
        return new Promise(function (resolve) {
            var clientApp = createApp(App, props);
            clientApp.mount(el);
            resolve({});
        });
    };
}
exports.clientSideMountFactory = clientSideMountFactory;
function serverSideMountFactory(App, _a) {
    var createSSRApp = _a.createSSRApp, renderToString = _a.renderToString;
    return function (props) {
        var ssrApp = createSSRApp(App, props);
        return renderToString(ssrApp).then(function (html) {
            return {
                html: html,
            };
        });
    };
}
exports.serverSideMountFactory = serverSideMountFactory;
function initializeWebComponent(__mfeName__, clientSideMount, childrenRemoteDeps) {
    if (childrenRemoteDeps === void 0) { childrenRemoteDeps = {}; }
    var selector = (0, utils_1.getWebComponentMFENameBy)(__mfeName__);
    (0, common_mfe_1.initializeComponent)(selector, __mfeName__, clientSideMount, childrenRemoteDeps);
}
exports.initializeWebComponent = initializeWebComponent;
function bootstrapClient(App, _a, __mfeName__) {
    var createApp = _a.createApp;
    return {
        __mfeName__: __mfeName__,
        clientSideMount: clientSideMountFactory(App, { createApp: createApp }),
    };
}
exports.bootstrapClient = bootstrapClient;
function bootstrapServer(App, _a, __mfeName__) {
    var createSSRApp = _a.createSSRApp, renderToString = _a.renderToString;
    return {
        __mfeName__: __mfeName__,
        serverSideMount: serverSideMountFactory(App, {
            createSSRApp: createSSRApp,
            renderToString: renderToString,
        }),
    };
}
exports.bootstrapServer = bootstrapServer;
